// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"23981f09","324":"5abfb9cf","453":"9a1ac91d","713":"5ab732e8","767":"aaea4831","947":"d2762759"}[chunkId] + ".chunk.js";
};